{
	"title": "Note legali",
	"backTitle": "Indietro",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Strasse 6",
			"city": "69120 Heidelberg",
			"country": "Germania"
		},
		"contact": {
			"telephone": "Telefono: +49 6221 481-0",
			"telefax": "Telefax: +49 6221 481-13553",
			"email": "Email: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Sede legale dell’azienda: Heidelberg",
			"commercialRegister": "Registro delle imprese: Mannheim, HRB 741878",
			"managingDirectors": "Amministratori delegati:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
